import ActionType from '../actions/ActionType'
import entityTypeColloquialMap from 'utils/entityTypeColloquialMap'

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

const doNotNotifyUpdated = {
	contact: true,
	account: true,
}

const statusMap = { L: 'live', P: 'paused' }

export const messageMap = (message, entityType) => {
	const vowels = { a: true, e: true, i: true, o: true, u: true }
	const n =
		typeof entityType === 'string' && vowels[entityType.slice(0, 1)] ? 'n' : ''

	const obj = {
		'delete dependency': 'This cannot be deleted.',
		'billing:new': jwtToken
			? 'Please login to the console to manage your subscription.'
			: 'Please enter a payment method.',
		'billing:active': jwtToken
			? 'Your subscription has been charged successfully!'
			: 'Successful subscription.',
		'billing:intrial': 'Your subscription is in trial.',
		'billing:nottrial': 'Your trial has ended. Please choose a plan.',
		'billing:canceled':
			'Your subscription has been cancelled. Please choose a plan to create a new subscription.',
		'billing:pastdue':
			'Your payment is past due. Please check your subscription settings.',
		'billing:pending': jwtToken
			? 'Please login to the console to manage your subscription.'
			: 'Your subscription has been charged unsuccessfully.',
		'billing:expired':
			'Your subscription is expired. Please choose a plan to create a new subscription.',
		'not updatable: live campaign stage task':
			'You cannot update this task because it is part of a campaign stage',
		'an entity with that name or id already exists': entityType
			? `A${n} ${entityType} with that name already exists. Please rename this.`
			: 'That name already exists. Please rename this.',
		'one or more json schema validaiton errors has occurred. See: [/schema/email/template/POST/request]':
			'Your email template fields have errors.',
	}

	return obj[message] || message
}

export default (state = [], action) => {
	switch (action.type) {
		case ActionType.Data.LIST_FAILURE:
			if (action.payload && typeof action.payload.message === 'string') {
				if (
					action.payload.message.toLowerCase() === 'failed to fetch' ||
					action.payload.message.toLowerCase() === 'token exp' ||
					action.payload.message.toLowerCase() === 'cannot parse token exp'
				) {
					return state
				}
			}
			return [
				...state,
				{
					details: Boolean(action.payload.additional_errors),
					type: 'error',
					message:
						action.payload && action.payload.message
							? messageMap(action.payload.message, action.entityType)
							: `There was an error retrieving this ${
									action.entityType.replace('/', ' ') || ''
							  } list.`,
				},
			]
		case ActionType.Data.CREATE_FAILURE:
			if (action.payload && typeof action.payload.message === 'string') {
				if (
					action.payload.message.toLowerCase() === 'failed to fetch' ||
					action.payload.message.toLowerCase() === 'token exp' ||
					action.payload.message.toLowerCase() === 'cannot parse token exp'
				) {
					return state
				}
			}
			return [
				...state,
				{
					details: Boolean(action.payload.additional_errors),
					type: 'error',
					message:
						action.payload && action.payload.message
							? messageMap(action.payload.message, action.entityType)
							: `There was an error creating this${
									action.entityType
										? ` ${
												entityTypeColloquialMap[action.entityType] ||
												action.entityType.replace('/', ' ')
										  }.`
										: '.'
							  }`,
				},
			]
		case ActionType.Data.UPDATE_FAILURE:
			if (action.payload && typeof action.payload.message === 'string') {
				if (
					action.payload.message.toLowerCase() === 'failed to fetch' ||
					action.payload.message.toLowerCase() === 'token exp' ||
					action.payload.message.toLowerCase() === 'cannot parse token exp'
				) {
					return state
				}
			}
			return [
				...state,
				{
					details: Boolean(action.payload.additional_errors),
					type: 'error',
					message:
						action.payload && action.payload.message
							? messageMap(action.payload.message, action.entityType)
							: // TODO: change the 'this' for applicable entities
							  `There was an error updating this${
									action.entityType
										? ` ${
												entityTypeColloquialMap[action.entityType] ||
												action.entityType.replace('/', ' ')
										  }.`
										: '.'
							  }`,
				},
			]
		case ActionType.Data.READ_FAILURE:
			if (action.payload && typeof action.payload.message === 'string') {
				if (
					action.payload.message.toLowerCase() === 'failed to fetch' ||
					action.payload.message.toLowerCase() === 'token exp' ||
					action.payload.message.toLowerCase() === 'cannot parse token exp'
				) {
					return state
				}
			}

      if (
        action.entityType === 'inbox/needsfollowup' &&
        (action.payload.message === 'not found' ||
          action.payload.http_status_code === 404)
      ) {
        return state
      }

			if (action.entityType !== 'campaigns_for_contact') {
				return [
					...state,
					{
						details: Boolean(action.payload.additional_errors),
						type: 'error',
						message:
							action.payload && action.payload.message
								? messageMap(action.payload.message, action.entityType)
								: `There was an error retrieving this${
										action.entityType
											? ` ${
													entityTypeColloquialMap[action.entityType] ||
													action.entityType.replace('/', ' ')
											  }.`
											: '.'
								  }`,
					},
				]
			}
			return state
		case ActionType.Data.DELETE_FAILURE:
			if (action.payload && typeof action.payload.message === 'string') {
				if (
					action.payload.message.toLowerCase() === 'failed to fetch' ||
					action.payload.message.toLowerCase() === 'token exp' ||
					action.payload.message.toLowerCase() === 'cannot parse token exp'
				) {
					return state
				}
			}
			return [
				...state,
				{
					details: Boolean(action.payload.additional_errors),
					type: 'error',
					message:
						action.payload && action.payload.message
							? messageMap(action.payload.message, action.entityType)
							: `There was an error deleting this${
									action.entityType
										? ` ${
												entityTypeColloquialMap[action.entityType] ||
												action.entityType.replace('/', ' ')
										  }.`
										: '.'
							  }`,
				},
			]
		case ActionType.Data.CREATE_SUCCESS:
			if (action?.snackbarMessage === 'none') {
        return state
      }
			
			return [
        ...state,
        {
          type: 'success',
          message:
            action?.snackbarMessage ||
            `Successfully added a new ${
              action.entityType
                ? ` ${
                    entityTypeColloquialMap[action.entityType] ||
                    action.entityType.replace('/', ' ')
                  }.`
                : '.'
            }`,
        },
      ]
		case ActionType.Data.UPDATE_SUCCESS:
			if (action?.snackbarMessage === 'none') {
        return state
      }

			return action.entityType && !doNotNotifyUpdated[action.entityType]
        ? [
            ...state,
            {
              type: 'success',
              message: `Successfully updated${
                action.entityType
                  ? ` ${
                      entityTypeColloquialMap[action.entityType] ||
                      action.entityType.replace('/', ' ')
                    }.`
                  : '.'
              }`,
            },
          ]
        : state
		case ActionType.Data.DELETE_SUCCESS:
			return action.entityType && action.snackbarMessage !== 'none'
        ? [
            ...state,
            {
              type: 'success',
              message:
                action?.snackbarMessage ||
                `${
                  action.entityType
                    ? `${
                        entityTypeColloquialMap[action.entityType] ||
                        action.entityType.replace('/', ' ')
                      } deleted.`
                    : 'Successfully deleted.'
                }`,
            },
          ]
        : state
		case ActionType.Campaign.UPDATE_STATUS_SUCCESS:
			return [
				...state,
				{
					type: action.newStatus ? statusMap[action.newStatus] : 'success',
					message: action.newStatus
						? `Campaign now ${statusMap[action.newStatus]}.`
						: 'Campaign status successfully changed.',
				},
			]
		case ActionType.View.CLOSE_SNACKBAR:
			return state.slice(1)
		case ActionType.View.OPEN_SNACKBAR:
			if (action.payload) {
				return [...state, action.payload]
			}
			return state
		case ActionType.Schemas.FAILURE:
			return [
				...state,
				{
					type: 'error',
					message:
						action.payload && action.payload.message
							? action.payload.message
							: 'An error has occurred.',
				},
			]
		case ActionType.Email.SEND_FAILURE:
			return [
				...state,
				{
					type: 'error',
					message:
						(action.payload && action.payload.message) ||
						'An error has occurred and your email did not send.',
				},
			]
		case ActionType.Email.SEND_SUCCESS:
			return [
				...state,
				{
					type: 'success',
					message: 'Email sent successfully!',
				},
			]
		case ActionType.SMS.SEND_FAILURE:
			return [
				...state,
				{
					type: 'error',
					message:
						(action.payload && action.payload.message) ||
						'An error has occurred and your text message did not send.',
				},
			]
		// case ActionType.SMS.SEND_SUCCESS:
		// 	return [
		// 		...state,
		// 		{
		// 			type: 'success',
		// 			message: 'Text message sent successfully!',
		// 		},
		// 	]
		case ActionType.Contacts.CREATE_SUCCESS:
			return [
				...state,
				{
					type: 'success',
					message: `Successfully added a new contact`,
				},
			]
		case ActionType.Contacts.UPDATE_SUCCESS:
			return [
				...state,
				{
					type: 'success',
					message: `Successfully updated contact`,
				},
			]
		case ActionType.Tasks.ADD_SUCCESS:
			return [
				...state,
				{
					type: 'success',
					message: `Successfully added a new task`,
				},
			]
		case ActionType.SignupForm.ADD_SUCCESS:
			return [
				...state,
				{
					type: 'success',
					message: `Successfully added a new signup form`,
				},
			]
		case ActionType.Contacts.CREATE_GROUP_SUCCESS:
			return [
				...state,
				{
					type: 'success',
					message: `Successfully added a new contact group`,
				},
			]
		case ActionType.Email.Templates.CREATE_SUCCESS:
			return [
				...state,
				{
					type: 'success',
					message: `Successfully added a new template`,
				},
			]
		case ActionType.Email.Templates.UPDATE_SUCCESS:
			return [
				...state,
				{
					type: 'success',
					message: 'Successfully updated template',
				},
			]
		case ActionType.Data.VALIDATION_FAILURE:
			return [
				...state,
				{
					details: action.errors && action.errors.length,
					type: 'error',
					message: 'There was an error, please check your fields',
				},
			]
		case ActionType.PAYMENTS_MANAGER.CREATE_SUBSCRIPTION_SUCCESS:
			return [
				...state,
				{
					type: 'success',
					message: "Successfully created your subscription"
				},
			]
		case ActionType.PAYMENTS_MANAGER.UPDATE_SUBSCRIPTION_SUCCESS:
			return [
				...state,
				{
					type: 'success',
					message: "Successfully updated your subscription"
				},
			]
		default:
			return state
	}
}
